<template>
    <div class="mt-5">
      <Loader :active="loading" mensaje="Cargando información" />
      <v-select v-if="operacion === 'Entrada'" @change="quienCubrir = ''" v-model="motivo" label="Motivo" placeholder="Seleccione una opción" :items="opciones"></v-select>
      <v-select v-if="motivo === 'cubrir_descanso'" v-model="quienCubrir" label="¿A quién cubriras?" placeholder="Seleccione un compañero" :items="mapTeammates"></v-select>
      <Camara :idNoProgramado="asistencia.id_np"  @entrada="updateAsistencia" :operacion="operacion" :noProgramada="true" :dataNoProgramada="getDataNoProgramada" />
    </div>
</template>
<script>
// Components
import Camara from '../components/Camara'
import Loader from '../components/Loader'
// Services
import { personal } from '../services/personal'
import { session } from '../services/session'
import { noProgramados } from '../services/no_programados'
export default {
  name: 'NoProgramados',
  components: {
    Camara,
    Loader
  },
  data () {
    return {
      motivo: '',
      quienCubrir: '',
      opciones: [
        { text: 'Cubrir descanso', value: 'cubrir_descanso' },
        { text: 'Día laboral no programado', value: 'no_programado' }
      ],
      teammates: [],
      dataUser: {
        idUsuario: ''
      },
      asistencia: {
        entrada: null,
        salida: null,
        idNp: null,
        id_np: ''
      },
      loading: true
    }
  },
  methods: {
    async getTeammates () {
      const { data } = await personal.partners(this.dataUser.idUsuario)
      return data
    },
    async asistencias () {
      const { data } = await noProgramados.asistencia(this.dataUser.idUsuario)
      return data
    },
    async getInfo () {
      try {
        const [
          teammates,
          asistencia
        ] = await Promise.all([
          this.getTeammates(),
          this.asistencias()
        ])
        const { idUsuario } = this.dataUser

        this.teammates = teammates.filter(teammate => teammate.id_usuario !== idUsuario)
        this.asistencia = (asistencia.version.length === 0) ? asistencia : asistencia.version[0]
      } catch (err) {
        this.showErrorMessage('Error al momento de obtener los datos')
      } finally {
        this.loading = false
      }
    },
    async updateAsistencia () {
      try {
        const { data } = await noProgramados.asistencia(this.dataUser.idUsuario)
        this.asistencia = data
      } catch (err) {
        this.showErrorMessage('Error al momento de obtener la asistencia no programada')
      }
    },
    showErrorMessage (message) {
      this.$toasted.show(message, {
        position: 'bottom-center',
        type: 'error',
        theme: 'bubble',
        duration: 5000
      })
    }
  },
  computed: {
    mapTeammates () {
      return this.teammates.map(user => {
        const { id_usuario: idUsuario, nombre, materno, paterno } = user
        return {
          text: `${nombre} ${paterno} ${materno}`,
          value: idUsuario
        }
      })
    },
    operacion () {
      if (this.asistencia.entrada === null) {
        return 'Entrada'
      } else if (this.asistencia.salida === null) {
        return 'Salida'
      } else {
        return 'completo'
      }
    },
    getDataNoProgramada () {
      if (this.motivo === '' && this.quienCubrir === '') return null

      else if (this.motivo === 'cubrir_descanso' && this.quienCubrir === '') return null

      const { text } = this.opciones.find(opcion => opcion.value === this.motivo)

      return {
        motivo: text,
        teammate: (this.quienCubrir === '') ? 0 : this.quienCubrir // En caso de día laborarl no Programado se mando un 0.
      }
    }
  },
  mounted () {
    this.dataUser = session.getData()
    this.getInfo()
  }
}
</script>
